"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var colors = _tokens.default.colors;

var ArrowWrapper = _styledComponents.default.span.withConfig({
  displayName: "ArrowWrapper",
  componentId: "sc-1xsx37u-0"
})(["svg{transform:rotate(", "deg);}"], function (props) {
  return props.rotate;
}); // eslint-disable-next-line react/prop-types


var ArrowSvg = function ArrowSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      rotate = _ref.rotate,
      strokeWidth = _ref.strokeWidth,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement(ArrowWrapper, {
    rotate: rotate
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 15",
    width: width,
    height: height,
    focusable: "false",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-29.000000, -141.000000)",
    fill: colors.legacy[color] || color,
    fillRule: "nonzero",
    stroke: colors.legacy[color] || color,
    strokeWidth: strokeWidth
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(24.000000, 132.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.7582701,10.1034718 C20.633334,9.96873963 20.4198135,9.96777297 20.2995226,10.0878053 C20.1772639,10.2097709 20.1682961,10.433669 20.2843612,10.5618346 L24.9315982,15.6659745 L6.32258232,15.6659745 C6.1444201,15.6659745 6,15.8152066 6,15.999305 C6,16.1834035 6.1444201,16.3326355 6.32258232,16.3326355 L24.9315982,16.3326355 L20.2843612,21.4367588 C20.1681993,21.5649244 20.1753606,21.7907891 20.2995226,21.9107881 C20.4235877,22.0307871 20.6232372,22.0337537 20.7582701,21.8951215 L25.9196356,16.2285031 C26.0423137,16.0725044 26.0100554,15.881306 25.9196356,15.770107 L20.7582701,10.1034718 Z"
  }))))));
};

var Arrow = (0, _styledComponents.default)(ArrowSvg).withConfig({
  displayName: "Arrow",
  componentId: "sc-1xsx37u-1"
})(["", " ", ""], _styledSystem.color, _styledSystem.layout);
Arrow.defaultProps = {
  color: "" + colors.brand.snswPrimaryBlue,
  height: 14,
  width: 22,
  marginRight: "0.5rem",
  rotate: 0,
  strokeWidth: .5
};
var _default = Arrow;
exports.default = _default;